export default __webpack_public_path__ + "static/media/uturn-right.651607fa.svg";